import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <g id="prefix__Group_2405" transform="translate(-46 -508)">
        <rect
          id="prefix__Rectangle_832"
          width={29}
          height={29}
          fill={props.fillSecondary}
          rx={10}
          transform="translate(46 508)"
        />
        <g id="prefix__Group_2349" transform="translate(48.768 435.3)">
          <g id="prefix__Group_2344" transform="translate(3.215 83.429)">
            <g id="prefix__Group_2343">
              <path
                id="prefix__Path_5520"
                d="M79.553 144h-1.12v7.32a2.109 2.109 0 01-2.1 2.111H60v1.307a1.047 1.047 0 001.023 1.05h18.53a1.047 1.047 0 001.023-1.05v-9.7A1.037 1.037 0 0079.553 144z"
                fill={props.fillPrimary}
                transform="translate(-60 -144)"
              />
            </g>
          </g>
          <g id="prefix__Group_2346" transform="translate(5.819 81.436)">
            <g id="prefix__Group_2345">
              <path
                id="prefix__Path_5521"
                d="M113.069 106.8a4.469 4.469 0 104.469 4.469 4.469 4.469 0 00-4.469-4.469zm2.426 1.652a.274.274 0 01-.274.274h-.93a.274.274 0 00-.235.416 1.673 1.673 0 01.2.5.274.274 0 00.266.208h.7a.275.275 0 010 .549h-.676a.272.272 0 00-.268.216 2.065 2.065 0 01-1.841 1.61.274.274 0 00-.153.455c.633.687 1.3 1.478 1.966 2.289a.275.275 0 01-.212.449h-.346a.275.275 0 01-.212-.1 61.601 61.601 0 00-2.534-2.908.275.275 0 01-.074-.188v-.3a.274.274 0 01.274-.274h.33c.978 0 1.583-.336 1.809-.879a.274.274 0 00-.257-.373h-1.881a.275.275 0 010-.549h1.765a.275.275 0 00.213-.448 1.829 1.829 0 00-1.473-.507h-.5a.275.275 0 01-.274-.275v-.165a.274.274 0 01.274-.274h4.076a.274.274 0 01.274.274z"
                fill={props.fillPrimary}
                transform="translate(-108.6 -106.8)"
              />
            </g>
          </g>
          <g id="prefix__Group_2348" transform="translate(0 80)">
            <g id="prefix__Group_2347">
              <path
                id="prefix__Path_5522"
                d="M19.554 80H1.023A1.047 1.047 0 000 81.05v9.7a1.037 1.037 0 001.023 1.04h18.53a1.041 1.041 0 001.023-1.04v-9.7A1.047 1.047 0 0019.554 80zM2.283 83.89a1.661 1.661 0 111.661-1.661 1.661 1.661 0 01-1.661 1.661zm8.006 7.556a5.543 5.543 0 115.54-5.546 5.543 5.543 0 01-5.54 5.546zm8-.257a1.661 1.661 0 111.661-1.661 1.661 1.661 0 01-1.661 1.661z"
                fill={props.fillPrimary}
                transform="translate(0 -80)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
